import _defineProperty from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
// ignore-string-externalization

/* stylelint-disable font-family-no-missing-generic-family-keyword */
import { css } from 'styled-components';
import { goldHighlight, btnFontSizeLg, btnPaddingLargeVertical, btnPaddingLargeHorizontal } from './variables';
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */

export var clearFix = function clearFix() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';
  var pseudoSelector = "".concat(parent, "::after");
  return _defineProperty({}, pseudoSelector, {
    clear: 'both',
    content: '""',
    display: 'table'
  });
};
export var textHide = css(["font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0;"]);
export var square = function square(size) {
  return css(["width:", ";height:", ";"], size, size);
};
export var imgCircle = css(["border-radius:50%;"]); // External arrow

export var iconExternalLink = function iconExternalLink() {
  var strokeColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : goldHighlight;
  return css(["background-image:url('data:image/svg+xml;utf8,<svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\"><title>Arrow</title><g stroke=\"", "\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M1 9l8-8\"/><path stroke-linejoin=\"round\" d=\"M2 .998h7V8\"/></g></svg>');"], strokeColor);
};
export var btnLg = function btnLg() {
  return css(["padding:", "px ", " ", "px;"], parseInt(btnPaddingLargeVertical, 10) + Math.floor(parseInt(btnFontSizeLg, 10) / 12), btnPaddingLargeHorizontal, parseInt(btnPaddingLargeVertical, 10) - Math.floor(parseInt(btnFontSizeLg, 10) / 12));
};